import fetch from "../components/Fetchinterceptor/FetchInterceptor";


const ContactService = {}
const apiRoute = '/contact-us';

ContactService.createContact = async function (data) {
    try {
        const res = await fetch({
            url: `${apiRoute}/create`,
            method: 'post',
            data: data,
        });
        return res;
    } catch (err) {
        console.log(err, 'show-err');
        return err
    }
}

export default ContactService;